import { render } from "./config.vue?vue&type=template&id=1b48cd86&scoped=true"
import script from "./config.vue?vue&type=script&lang=js"
export * from "./config.vue?vue&type=script&lang=js"

import "./config.vue?vue&type=style&index=0&id=1b48cd86&lang=scss&scoped=true"

import exportComponent from "D:\\lpl\\szy\\cloud-api-web-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b48cd86"]])

export default __exports__